import { render } from "./PageIndexSix.vue?vue&type=template&id=d028279c"
import script from "./PageIndexSix.vue?vue&type=script&lang=js"
export * from "./PageIndexSix.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__